export default __webpack_public_path__ + "static/media/View-2.e1bc464e.svg";